import Controller from "./pricings.controller";
import template from "./pricings.html";

const pricings = {
  template,
  controller: Controller,
};

export default pricings;



// WEBPACK FOOTER //
// ./src/pages/pricings/pricings.component.js